import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

console.log('[forge-standalone-baic-app] Using hierarchical configuration system');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);
